// Yield control back to the event loop between heavy phases of a long task so
// the browser can paint and process input. Prefers scheduler.yield() (Chrome
// 129+, continuation-preserving priority) and falls back to a macrotask.
type GlobalWithScheduler = typeof globalThis & {
  scheduler?: { yield?: () => Promise<void> };
};

export const yieldToMain = (): Promise<void> =>
  new Promise((resolve) => {
    const settle = () => setTimeout(() => resolve(), 0);
    const schedulerYield = (globalThis as GlobalWithScheduler).scheduler?.yield;
    if (typeof schedulerYield === "function") {
      schedulerYield.call((globalThis as GlobalWithScheduler).scheduler).then(
        () => resolve(),
        settle,
      );
      return;
    }
    settle();
  });
